export default __webpack_public_path__ + "static/norrkoping_logo-5316611a934869617fc78010a31d9777.png";